import { jsx as _jsx } from "react/jsx-runtime";
import { Heading } from '@beamery/lib-ds-components';
export const HeaderOne = (props) => _jsx(Heading, Object.assign({}, props, { variant: '1' }));
export const HeaderTwo = (props) => _jsx(Heading, Object.assign({}, props, { variant: '2' }));
export const HeaderThree = (props) => _jsx(Heading, Object.assign({}, props, { variant: '3' }));
export const HeaderFour = (props) => _jsx(Heading, Object.assign({}, props, { variant: '4' }));
export const HeaderFive = (props) => _jsx(Heading, Object.assign({}, props, { variant: '5' }));
